import {moment, get, toNumber, Base64} from 'helpers';
import {format} from './convert';

export function activity(activity) {
  return {
    allDay: parseInt(activity.allDay),
    category: Base64.decode(activity['category-name']),
    dailyRoutineId: activity.dailyRoutineId > 0 ? activity.dailyRoutineId : null,
    dailyRoutineType: activity.type,
    dayParts: activity.dayParts,
    duration: toNumber(activity.duration),
    endDate: parseInt(activity.endDate||'0') && moment(activity.endDate, format).unix(),
    goal_id: activity.goalId > 0 ? activity.goalId : undefined,
    googleCalendarId: activity.googleCalendarId,
    googleEventId: activity.googleEventId,
    habitTypeId: activity.habitTypeId > 0 ? activity.habitTypeId : undefined,
    id: activity.serverId,
    importedEvent: parseInt(activity.importedEvent) > 0,
    iOSCalendarId: activity.iOSCalendarId,
    iOSEventId: activity.iOSEventId,
    isRecurring: activity.isRecurring,
    isTemplate: parseInt(activity.isTemplate),
    localMark: activity.localMark,
    months: activity.months,
    name: Base64.decode(activity.name),
    note: activity.notes,
    numericalTarget: activity.numericalTarget,
    numericalTargetUnit: activity.numericalTargetUnit,
    orderIndex: activity.orderIndex,
    priority: get(priorities, activity.priority, ''),
    reminder: activity.reminder,
    reminderInterval: toNumber(activity.reminderInterval),
    repeatCount: activity.repeatCount,
    repeatCountPerDay: activity.repeatCountPerDay,
    repeatDays: activity.repeatDays,
    repeatType: activity.repeatType,
    repetitionInterval: activity.repetitionInterval,
    result: parseInt(activity.targetValue) || 0,
    scheduleDate: activity.scheduleDate && moment(activity.scheduleDate, format).unix(),
    status: activity.status || 'Not Started',
    tagIds: activity.tagIds,
    time: activity.time,
    timeInterval: activity.timeInterval,
    times: activity.times,
    ts: activity.date && moment(activity.date, format).unix(),
    unit: activity.unit,
    unitId: activity.unitId,
  }
}

const priorities = {
  'High': 'High',
  'Highest': 'Highest',
  'Must do': 'Highest',
}
